
<template>
  <div  class="app-container">
    <div class="title-container" shadow="never" style="margin-top: 0px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOneDlg()">增加泳圈</el-button>
      </div>
    </div>
    <div class="table-container" shadow="never" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        highlight-current-row
        max-height="580"
        v-loading="listLoading" border>
        <el-table-column type="selection" width="120"></el-table-column>
        <el-table-column prop="name" label="泳圈名" ></el-table-column>
        <el-table-column prop="statuDes" label="启用状态" ></el-table-column>
        <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button @click="handleForbitOne(scope.row)" type="warning" size="small" plain v-if="scope.row.statu == 0">禁用</el-button>
            <el-button @click="handleUseOne(scope.row)" type="primary" size="small" plain v-if="scope.row.statu == 1">启用</el-button>
            <el-button @click="handleDeleteOne(scope.row)" type="danger" size="small" plain>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="删除泳圈"
      :visible.sync="visibleDlgDelete"
      width="50%"
      center>
      <div class="edit-area">
        <el-row style="margin-top: 10px">
          <el-col :span="10" ><div style="margin-top: 10px;margin-left: 30px">职位  :</div></el-col>
          <el-col :span="14" ><div style="margin-top: 10px;margin-left: 30px">{{deleteParam.position}}</div></el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgDelete = false">取消</el-button>
        <el-button type="primary" @click="visibleDlgDelete = false">删除</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="新增泳圈"
      :visible.sync="visibleDlgAdd"
      width="50%"
      center>
      <div class="root-container">
        <el-form  ref="registerRef"  :model="createParam" :rules="rules" label-width="140px" >
          <el-form-item  label="泳圈型号名"  prop="name">
            <el-input style="width: 300px" v-model="createParam.name" placeholder="输入卡名称"></el-input>
          </el-form-item>
          <el-form-item  label="启用状态" prop="statu">
            <el-select v-model="createParam.statu" placeholder="请选择" style="width: 300px">
              <el-option
                v-for="item in swStatu"
                :key="item.statu"
                :label="item.des"
                :value="item.statu">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne('registerRef')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import globaldata from "../../../../utils/globaldata";
  import {selectWorkerPosition, updateposition} from "../../../../api/storeFront";
  import commonUtils from "../../../../utils/commonUtils";
  import messageUtils from "../../../../utils/messageUtils";
  import {qlSwCircle, updateSwCle} from "../../../../api/StoreSetting";

  export default {
    data() {
      return {
        listLoading: true,
        rules:{
          name:[{required:true,message:"请输入泳圈名",trigger:"blur"}],
          statu:[{required:true,message:"请选择状态",trigger:"blur"}]
        },
        visibleDlgAdd :false,
        visibleDlgDelete :false,
        //表单结果
        tableData: [
        ],
        createParam:{
          name:"",
          statu:"",
        },
        deleteParam :{
          position :'',
        },
        swStatu:[
          {
            statu:0,
            des:"启用"
          },
          {
            statu:1,
            des:"禁用"
          }
        ]

      }
    },
    mounted() {
      this.flechList();
    },
    methods: {
      flechList(){
        this.listLoading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId
        }
        qlSwCircle(param).then(response => {
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.refreshData(date);

        })
      },

      getStatuDes(statu){
        for (let i = 0;i<this.swStatu.length;++i){
          if (this.swStatu[i].statu == statu){
            return this.swStatu[i].des
          }
        }
      },
      //刷新页面数据
      refreshData(data){
        if (commonUtils.isObjectNull(data)){
          return;
        }
        let list = data;
        this.tableData = [];
        for (let i = 0;i< list.length;++i){
          if (list[i].length <=0){
            continue;
          }
          let data = {
            number : i+1 ,
            name:list[i].name,
            statu:list[i].statu,
            statuDes : this.getStatuDes(list[i].statu)
          };
          this.tableData.push(data);
        }
      },
      handleDeleteOne(row){
        let index = row.number -1;
        this.tableData.splice(index,1);
        this.doUpdateSw();
      },
      //禁用
      handleForbitOne(row){
        row.statu = 1;
        this.doUpdateSw();
      },
      //启用
      handleUseOne(row){
        row.statu = 0;
        this.doUpdateSw();
      },

      doUpdateSw(){
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          swimCircleDetails:[]
        }
        for (let i = 0;i< this.tableData.length;++i){
          let data = {
            name: this.tableData[i].name,
            statu:this.tableData[i].statu
          }
          param.swimCircleDetails.push(data);
        }
        updateSwCle(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          if (date == true){
            messageUtils.successMsg(this,response.message);
            this.flechList();
          }
        })
      },
      //添加
      handleCreateOneDlg(){
        this.visibleDlgAdd = true;
      },
      handleCreateOne(registerRef){
        this.$refs[registerRef].validate((valid) => {
          if (valid) {
            //不能添加重复的
            for(let i = 0;i< this.tableData.length;++i){
              if (this.createParam.name == this.tableData[i].name) {
                messageUtils.errorMsg(this,"不能添加重复泳圈")
                return ;
              }
            }

            let data = {
              name:this.createParam.name,
              statu:this.createParam.statu,
            };
            let t = this.tableData;
            t.push(data);
            this.doUpdateSw();
          } else {
            return false
          }
        });

      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/store-setting/sw-circle/index.vue